<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.Asset">Asset</mat-card-title>
  <mat-card-content>

    <app-asset-search-filters></app-asset-search-filters>
    <form [formGroup]="searchForm">
      <div class="search-section">

        <mat-form-field class="field-quarter-width">
          <mat-label i18n="@@actions.reportRun.format">Format</mat-label>
          <mat-select [(ngModel)]="reportRun.outputFormat" formControlName="outputFormat" id="outputFormat"
            name="outputFormat" required>
            <mat-option *ngFor="let outputFormat of reportRun.outputFormats" [value]="outputFormat">
              {{outputFormat.name | refCodeDecode:'REPORT_OUTPUT_FORMAT' | async }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <span>
          <mat-checkbox [(ngModel)]="reportRun.download" formControlName="download" id="download" name="download"
            class="field-quarter-width" labelPosition="after" disabled="{{reportRun.outputFormat?.downloadOnly}}"
            i18n="@@actions.reportRun.download">Download
          </mat-checkbox>
        </span>

        <button mat-raised-button color="primary" class="action-button" (click)="exportAction()" type="button"
        i18n="@@actions.reportRun" [disabled]="!isExportEnabled()">Export</button>

        <mat-slide-toggle floatLabel="always" appearance="none" color="primary" *ngIf="autoSearchControlsEnabled"
          [(ngModel)]="autoSearch" [ngModelOptions]="{standalone: true}">
          Auto Search
        </mat-slide-toggle>

        <button mat-raised-button color="primary" class="action-button" (click)="forceSearch()" type="button"
          i18n="@@actions.search">Search</button>


        <button mat-raised-button color="primary" class="action-button" (click)="clearFilters()" type="button"
          [disabled]="!allowsClearFilters()" i18n="@@actions.clearFilters">Clear Filters</button>
      </div>
    </form>

    <div class="mat-elevation-z8">
      <div class="mat-table-wrapper">
        <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc" matSortDisableClear cdkDropList
          cdkDropListLockAxis="x" cdkDropListOrientation="horizontal"
          (cdkDropListDropped)="columns.dropListDropped($event)" Group>

          <app-asset-search-result-columns [columns]="columns"></app-asset-search-result-columns>

          <ng-container matColumnDef="actions" stickyEnd>
            <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
              <span i18n="@@common.actions">Actions</span>
              <app-column-picker-dialog-launcher [columns]="columns">
              </app-column-picker-dialog-launcher>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="search-column-actions mat-elevation-z9">
              <button class="action-button" *ngIf="allowsEdit(element)" mat-raised-button color="primary"
                [routerLink]="editRoute(element)" [queryParams]="editRouteQueryParams()" i18n="@@actions.edit"
                id="actions.edit">Edit</button>
              <button class="action-button" [queryParams]="viewRouteQueryParams()" *ngIf="allowsView(element)"
                mat-raised-button color="primary" [routerLink]="viewRoute(element)" i18n="@@actions.view"
                id="actions.view">View</button>
              <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

        </mat-table>
      </div>
      <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
      </mat-paginator>

      <button class="action-button" *ngIf="allowsCreate()" mat-raised-button color="primary"
        [routerLink]="createRoute()" [queryParams]="createRouteQueryParams()" i18n="@@actions.create"
        id="actions.create">Create</button>
      <button class="action-button" *ngIf="allowsBack()" mat-raised-button color="accent" [routerLink]="backRoute()"
        [queryParams]="backRouteQueryParams()" i18n="@@actions.back" id="actions.back">Back</button>
    </div>
  </mat-card-content>
</mat-card>